import { endpoint } from "views/pages/manage/common/constant";
import {
  fetchAllPromisedData,
  fetchAllPostPromisedData,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { dropdownMapping } from "../../../constant/batch-search";
import store from "redux/store";
import { LastUpdatedDetails } from "../../materialDistribution/helper";

export const searchCourseMaterialMapping = async ({
  request = {},
  page = 0,
  limit,
}) => {
  const payloadWithIds = structureFiltersPayload(request);
  const response = await fetchAllPostPromisedData(
    `${endpoint.courseMaterialMapping.searchMapping}?offset=${page}&limit=${limit}`,
    {
      ...payloadWithIds,
    },
    "post"
  );

  return response?.data || {};
};

export const getMappingById = async (id) => {
  const response = await fetchAllPromisedData(
    `${endpoint.courseMaterialMapping.getMappingById}/${id}`
  );

  return response;
};

export const createNewMapping = async (payload) => {
  const request = createBody(payload);
  const response = await fetchAllPostPromisedData(
    `${endpoint.courseMaterialMapping.createMapping}`,
    {
      ...request,
    },
    "post"
  );

  return response || {};
};

export const editCourseMaterialMapping = async ({ id, payload }) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.courseMaterialMapping.editMapping}/${id}`,
    payload?.materialInfo ? createBody(payload) : payload,
    "put"
  );

  return response || {};
};

export const deleteCourseMaterialEntry = async (id) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.courseMaterialMapping.deleteMapping}/${id}`,
    {},
    "delete"
  );

  return response || {};
};

export const getCourseIds = async ({
  languageId,
  academicCareerId,
  attribute,
  classId,
  boardId = null,
  academicGroupId = null,
}) => {
  const request = {
    academicCareer: academicCareerId,
    classes: classId,
    languageId: languageId,
    attributeValue: attribute,
    ...(boardId && { boardId }),
    ...(academicGroupId && { academicGroupId }),
  };

  const response = await fetchAllPostPromisedData(
    `${endpoint.courseCatelogMapping.getCoursesByCareerClassLangAttribute}`,
    request,
    "post"
  );

  if (response.code !== 200) return [];

  return response.data?.map(({ courseId, courseDescription }) => ({
    label: `${courseId} | ${courseDescription}`,
    value: courseId,
    courseDescription,
  }));
};

export const fetchLangAttributeMasterDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(
      endpoint.academic_career.getAllActive,
      "academicCareerDispValue"
    ),
    dropdownMapping(endpoint.classes.getAll, "classDispValue"),
    dropdownMapping(
      endpoint.languageMaster.getActiveLanguageMaster,
      "languageDispValue"
    ),
    dropdownMapping(
      `${endpoint.getCourseAttributeValuesByCourseAttributeKey}?courseAttributeKey=CORP`,
      "corpValues"
    ),
    dropdownMapping(
      `${endpoint.examBoardType.getAll}`,
      "examBoardTypeDispValue"
    ),
    dropdownMapping(
      `${endpoint.academic_group.getAllActive}`,
      "academicGroupDispValue"
    ),
  ]);

  return {
    academicCareer: p[0],
    classes: p[1],
    languages: p[2],
    attribute: p[3],
    board: p[4],
    stream: p[5],
  };
};

export const joinCourseIds = (courseIdArray) =>
  courseIdArray?.map((obj) => obj.value)?.join(", ");

export const extractPkgCode = (apiResponse) =>
  apiResponse.map((item) => item.packageCodeId).join(", ");

export const extractAndJoinMaterialIds = (materialInfo) => {
  return materialInfo
    .map((mat) => mat.materialIds.map((obj) => obj.value))
    .join(", ");
};

const structureFiltersPayload = (filters) => {
  const temp = { ...filters };

  for (const key in filters) {
    if (
      Array.isArray(filters[key]) &&
      ["academicCareer", "attribute", "language"].includes(key)
    ) {
      const filterLabels = filters[key]?.map((option) => option.label);

      temp[key] = filterLabels;
    } else if (key === "searchBy" && temp[key] === "materialId") {
      temp["searchByValue"] = filters["searchByValue"].materialId;
    } else if (Array.isArray(filters[key])) {
      const filterValues = filters[key]?.map((option) => option.value);

      temp[key] = filterValues;
    } else if (["board", "stream"].includes(key))
      temp[key] = filters[key].label ? [filters[key].label] : [];
  }
  return temp;
};

export const structureDataIntoForm = (apiResponse) => {
  const masterDropdowns = store.getState().globalData?.masterDropdowns;
  const { academicCareer, classes, languages, attribute, board, stream } =
    masterDropdowns;

  return {
    language: languages.find(
      (op) => op.label.toLowerCase() === apiResponse.language.toLowerCase()
    ),
    academicCareer: academicCareer.find(
      (op) =>
        op.label.toLowerCase() === apiResponse.academicCareer.toLowerCase()
    ),
    attribute: attribute.find(
      (op) => op.label.toLowerCase() === apiResponse.attribute.toLowerCase()
    ),
    classes: classes.find((op) => op.value.toString() === apiResponse.classes),
    board: board.find(
      (op) => op.label.toLowerCase() === apiResponse.board.toLowerCase()
    ),
    stream: stream.find(
      (op) => op.label.toLowerCase() === apiResponse.stream.toLowerCase()
    ),
    year: { label: apiResponse.year, value: apiResponse.year },
    courses: apiResponse.courseIds?.map(({ label, value }) => ({
      courseDescription: label,
      label: `${value} | ${label}`,
      value,
    })),
    materialInfo: apiResponse.materialInfo.map(
      ({ packageCodeId, materialIds }, index) => ({
        packageCodeId,
        materialIds: materialIds.map(({ label, value }) => ({
          label: `${value} | ${label}`,
          value,
          materialDescription: label,
        })),
        id: index + 1,
      })
    ),

    createdOn: LastUpdatedDetails(
      apiResponse?.createdOn,
      apiResponse?.createdBy
    ),
    createdBy: apiResponse?.createdBy,
    updatedOn: LastUpdatedDetails(
      apiResponse?.updatedOn,
      apiResponse?.updatedBy
    ),
    updatedBy: apiResponse?.updatedBy,
  };
};

export const createBody = (payload) => {
  return {
    academicCareer: payload.academicCareer.label,
    classes: payload.classes.value,
    attribute: payload.attribute.label,
    language: payload.language.label,
    board: payload.board.label,
    stream: payload.stream.label,
    year: payload.year.label,

    status: "ACTIVE",
    courseIds: payload.courses.map((item) => ({
      label: item.courseDescription,
      value: item.value,
    })),
    materialInfo: payload.materialInfo.map(
      ({ packageCodeId, materialIds }) => ({
        packageCodeId,
        materialIds: materialIds.map((mat) => ({
          label: mat.materialDescription,
          value: mat.value,
        })),
      })
    ),
  };
};
